import { DomainSchema } from '@multitec/domain'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { Base } from '../base'
import { MyURLSearchParams } from '../utils/url-search-params'

class LoadByVista extends Base {
  private response = z.array(
    z.object({
      ...DomainSchema.EquipmentVistaItem.shape,
      Product: DomainSchema.Product,
      Vista: DomainSchema.EquipmentVista,
    }),
  )

  handle = (vista_id?: string | number | null) => {
    return useQuery(
      ['equipment-vista-item', 'load-by-vista', { vista_id }],
      async () => {
        if (!vista_id) return []

        const queryParams = new MyURLSearchParams({
          vistaId: vista_id,
        }).toString()
        const { data } = await this.axios.get(
          '/entity/vista-products?' + queryParams,
        )
        return this.response.parse(data.result)
      },
    )
  }
}

export default class extends Base {
  LoadByVista = new LoadByVista(this.axios).handle
}
